import { getShortUrl } from '@sigma-frontend-libs/commons'

import render from './render'

export const fields = [ 'shortUrl', 'fullUrl', 'domain', 'clientIp', 'userAgent', 'language', 'countryCode', 'visitedAt' ]

export default {
  name: 'Form',

  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    },

    paddless: Boolean
  },

  computed: {
    rows() {
      return fields.reduce((result, field) => {
        switch (field) {
          case 'shortUrl': {
            result[field] = getShortUrl(this.value)
            break
          }
          default: {
            result[field] = this.value[field]
            break
          }
        }

        return result
      }, {})
    }
  },

  render
}
